(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('NewFeatureDialogController', NewFeatureDialogController);

    NewFeatureDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'NewFeature', 'File', 'Brokerage', 'AppraisalFirm'];

    function NewFeatureDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, NewFeature, File, Brokerage, AppraisalFirm) {
        var vm = this;

        vm.feature = entity;
        
        if(vm.feature.image == null) {
            vm.feature.image = {};
        }

        vm.checkDates = checkDates;
        vm.clear = clear;
        vm.save = save;
        vm.removeImage = false;
        vm.newImages = [];
        vm.oldFileId = null;

        // ---- Optional per-company targeting ----------------------------------------------
        // A feature with no companies selected is unrestricted and goes to its whole target
        // audience, which is the default and how every pre-existing feature behaves. The
        // checkbox is derived from the selections rather than stored, so the two can never
        // disagree.

        if (!vm.feature.appraisalFirms) {
            vm.feature.appraisalFirms = [];
        }
        if (!vm.feature.brokerages) {
            vm.feature.brokerages = [];
        }

        vm.restrictToCompanies = vm.feature.appraisalFirms.length > 0
            || vm.feature.brokerages.length > 0;

        vm.appraisalFirms = [];
        vm.brokerages = [];
        vm.selectedAppraisalFirm = null;
        vm.selectedBrokerage = null;
        vm.appraisalFirmSearchText = '';
        vm.brokerageSearchText = '';

        vm.canPickAppraisalFirms = canPickAppraisalFirms;
        vm.canPickBrokerages = canPickBrokerages;
        vm.syncCompanySelections = syncCompanySelections;
        vm.companySelectionIncomplete = companySelectionIncomplete;
        vm.lopsidedAllWarning = lopsidedAllWarning;

        vm.matchAppraisalFirms = matchAppraisalFirms;
        vm.getAppraisalFirmText = getAppraisalFirmText;
        vm.addAppraisalFirm = addAppraisalFirm;

        vm.matchBrokerages = matchBrokerages;
        vm.getBrokerageText = getBrokerageText;
        vm.addBrokerage = addBrokerage;

        // The -minimal endpoints are unpaged and return just {id, name, disabled}, so one text
        // formatter serves both and there is no page-size ceiling to trip over.
        AppraisalFirm.getDropDownAppraisalFirms().$promise.then(function(appraisalFirms) {
            vm.appraisalFirms = appraisalFirms;
        });

        Brokerage.getDropDownBrokerages().$promise.then(function(brokerages) {
            vm.brokerages = brokerages;
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            // Authoritative pass: a selection the current target no longer allows must not reach
            // the server even if the ng-change wiring were bypassed.
            syncCompanySelections();

            vm.feature.appraisalFirmIds = (vm.feature.appraisalFirms || []).map(function(firm) {
                return firm.id;
            });
            vm.feature.brokerageIds = (vm.feature.brokerages || []).map(function(brokerage) {
                return brokerage.id;
            });

            var saveFeature = function() {

                if (vm.feature.id !== null) {
                    NewFeature.update(vm.feature, onSaveSuccess, onSaveError);
                } else {
                    NewFeature.save(vm.feature, onSaveSuccess, onSaveError);
                }
            }

            if(vm.newImages.length > 0) {
                saveFile(saveFeature, onSaveError)
            } else {
                if(vm.removeImage) {
                    delete vm.imageId
                }

                saveFeature();
            }
        }

        function saveFile(onSaveSuccess, onSaveError) {
            var multipartData = new FormData();

            console.log(vm.newImages[0].lfFile)
            multipartData.append("file", vm.newImages[0].lfFile); 

            File.upload(multipartData).$promise.then(function(file) {
                vm.oldFileId = vm.feature.imageId
                vm.feature.imageId = file.id

                onSaveSuccess();
            })
            .catch(function() {
                console.error("Error saving file");
                onSaveError();
            });
        }

        function onSaveSuccess (result) {
            $scope.$emit('valueconnectApp:newFeatureUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;

            if(vm.oldFileId != null) {
                File.delete(vm.feature.imageId)
                vm.feature.imageId = vm.oldFileId
            }
        }

        function checkDates() {
            // Make sure the to date is not less than the from date
            if (vm.feature.startDate && vm.feature.endDate) {
                return new Date(vm.feature.startDate).getTime()
                    <= new Date(vm.feature.endDate).getTime();
            }

            return true;
        }

        function canPickAppraisalFirms() {
            return vm.restrictToCompanies
                && (vm.feature.target === 'APPRAISER' || vm.feature.target === 'ALL');
        }

        function canPickBrokerages() {
            return vm.restrictToCompanies
                && (vm.feature.target === 'ORIGINATOR' || vm.feature.target === 'ALL');
        }

        /**
         * Drops any selection the current state disallows. Bound to both the target select and
         * the checkbox, which is what gives us two behaviours for free: unchecking clears both
         * lists, and switching target clears only the list that just became invalid while
         * leaving the checkbox ticked.
         */
        function syncCompanySelections() {
            if (!canPickAppraisalFirms()) {
                vm.feature.appraisalFirms = [];
                vm.selectedAppraisalFirm = null;
                vm.appraisalFirmSearchText = '';
            }
            if (!canPickBrokerages()) {
                vm.feature.brokerages = [];
                vm.selectedBrokerage = null;
                vm.brokerageSearchText = '';
            }
        }

        /**
         * Ticked but nothing chosen would persist as "everyone" -- the opposite of the intent --
         * so the save button stays disabled until a company is picked or the box is unticked.
         */
        function companySelectionIncomplete() {
            return vm.restrictToCompanies
                && vm.feature.appraisalFirms.length === 0
                && vm.feature.brokerages.length === 0;
        }

        /**
         * Naming any company narrows the whole feature, so an ALL feature scoped on only one
         * side reaches nobody on the other. Correct, but surprising enough to warn about.
         */
        function lopsidedAllWarning() {
            if (!vm.restrictToCompanies || vm.feature.target !== 'ALL') {
                return null;
            }

            var firms = vm.feature.appraisalFirms.length;
            var brokerages = vm.feature.brokerages.length;

            if (firms > 0 && brokerages === 0) {
                return 'noOriginators';
            }
            if (brokerages > 0 && firms === 0) {
                return 'noAppraisers';
            }

            return null;
        }

        function companyText(company) {
            if (!company) {
                return '';
            }

            var text = company.id + ': ' + company.name;

            if (company.disabled) {
                text += ' (Disabled)';
            }

            return text;
        }

        function matchCompanies(available, selected, searchText) {
            if (!available) {
                return [];
            }

            var unselected = available.filter(function(company) {
                return !selected.some(function(chosen) {
                    return chosen.id === company.id;
                });
            });

            if (!searchText) {
                return unselected;
            }

            var searchRegex = new RegExp(searchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i');
            return unselected.filter(function(company) {
                return searchRegex.test(companyText(company));
            });
        }

        function getAppraisalFirmText(appraisalFirm) {
            return companyText(appraisalFirm);
        }

        function matchAppraisalFirms(searchText) {
            return matchCompanies(vm.appraisalFirms, vm.feature.appraisalFirms, searchText);
        }

        function addAppraisalFirm(appraisalFirm) {
            if (appraisalFirm && !vm.feature.appraisalFirms.some(function(chosen) {
                return chosen.id === appraisalFirm.id;
            })) {
                vm.feature.appraisalFirms.push(appraisalFirm);
            }

            vm.selectedAppraisalFirm = null;
            vm.appraisalFirmSearchText = '';
        }

        function getBrokerageText(brokerage) {
            return companyText(brokerage);
        }

        function matchBrokerages(searchText) {
            return matchCompanies(vm.brokerages, vm.feature.brokerages, searchText);
        }

        function addBrokerage(brokerage) {
            if (brokerage && !vm.feature.brokerages.some(function(chosen) {
                return chosen.id === brokerage.id;
            })) {
                vm.feature.brokerages.push(brokerage);
            }

            vm.selectedBrokerage = null;
            vm.brokerageSearchText = '';
        }

        vm.setFileData = function ($file, file) {
            if (!$file) {
                return
            }

            console.log($file)

            $scope.$apply(function() {
                file.contentType = $file.type;
                file.fileName = $file.name;
            });
        };
    }
})();
